// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
import {
  StyledMobileBoxItem,
  StyledMobileBoxItemRow,
  StyledMobileBoxLabel,
} from '../../utils/Styles/DataBoxStyles';
import DollarOutput from '../../utils/DollarOutput';

const PartyOrdersListMobile = ({
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  orders,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  getEventDate,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  getOrderPlacedDate,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  onOrderClick,
}) => (
  <div>
    {/* TODO: Fix this the next time the file is edited. */}
    {/* eslint-disable-next-line react/prop-types */}
    {orders.map(order => (
      <StyledMobileBoxItem
        key={order.id}
        onClick={onOrderClick}
        href={`/orders/${order.id}`}
      >
        <StyledMobileBoxItemRow maxWidth='100%'>
          Order name: <span>{order.name}</span>
        </StyledMobileBoxItemRow>
        <StyledMobileBoxLabel>{order.status}</StyledMobileBoxLabel>
        <StyledMobileBoxItemRow>
          Event Date: <span>{getEventDate(order)}</span>
        </StyledMobileBoxItemRow>
        <StyledMobileBoxItemRow>
          Customer Name: <span>{order.customer?.memberName || ''}</span>
        </StyledMobileBoxItemRow>
        <StyledMobileBoxItemRow maxWidth='100%'>
          Price:{' '}
          <span>
            <DollarOutput value={order.totalPrice} />
          </span>
        </StyledMobileBoxItemRow>
        <StyledMobileBoxItemRow maxWidth='100%'>
          Order Placed:
          <span>{getOrderPlacedDate(order)}</span>
        </StyledMobileBoxItemRow>
      </StyledMobileBoxItem>
    ))}
  </div>
);

export default PartyOrdersListMobile;
